import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { setItem } from 'api/actions';
import _ from 'lodash';
import { connect, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import Select from 'react-select';
import * as actions from './actions';
import * as c from './constant';

const OrdinanceRevisionDropDown = ({
  getOrdinanceRevisionEffectivity,
  ordinanceRevisionEffectivity,
  selectedOption,
  pathName,
}) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState(selectedOption);

  const effectivityOptions =
    ordinanceRevisionEffectivity.map(data => {
      return {
        value: data.id,
        label: data.attributes.effectivity,
      };
    }) || {};

  const defaultFormValue = { year: effectivityOptions[0] };
  useEffect(() => {
    getOrdinanceRevisionEffectivity();
  }, []);

  useEffect(() => {
    dispatch(setItem(c.GET_FORMDATA_ORDINANCE_REVISION, formData));
    // dispatch(setItem(c.GET_FORMDATA_ORDINANCE_REVISION_DEFAULT, defaultFormValue))
  }, [formData]);

  useEffect(() => {
    localStorage.setItem('formData', JSON.stringify(formData));
    localStorage.setItem('defaultFormValue', JSON.stringify(defaultFormValue));
  }, [formData, defaultFormValue]);

  const handleChangeSelect = key => e => {
    setFormData({
      ...formData,
      [key]: e,
    });
  };

  const styles = {
    control: base => ({
      ...base,
      minHeight: 24,
      width: '200px',
    }),
    dropdownIndicator: base => ({
      ...base,
      paddingTop: 0,
      paddingBottom: 0,
      color: '#7790CB',
      clipPath: 'polygon(50% 70%, 30%  35%, 70% 35%)',
      backgroundColor: '#7790CB',
    }),
    clearIndicator: base => ({
      ...base,
      paddingTop: 0,
      paddingBottom: 0,
    }),
  };

  return (
    <div className="dropdown-menu-container d-flex justify-content-end">
      {`${pathName.indexOf('bpls/new-business/new-business-natures')}` > -1 ||
      `${pathName.indexOf('bpls/tax-revenue')}` > -1 ? (
        <>
          <label
            className="dropdown-menu-title mr-2 my-auto cms-text-primary"
            style={{ color: '#4C6085' }}
          >
            <b>YEAR</b>
          </label>
          <Select
            styles={styles}
            placeholder="Select year"
            value={
              _.isEmpty(_.get(formData, 'year'))
                ? _.get(defaultFormValue, 'year')
                : _.get(formData, 'year')
            }
            options={effectivityOptions}
            onChange={handleChangeSelect('year')}
          />
        </>
      ) : (
        ''
      )}
    </div>
  );
};

OrdinanceRevisionDropDown.defaultProps = {
  selectedOption: {},
};

OrdinanceRevisionDropDown.propTypes = {
  ordinanceRevisionEffectivity: PropTypes.instanceOf(Object).isRequired,
  selectedOption: PropTypes.instanceOf(Object),
  getOrdinanceRevisionEffectivity: PropTypes.instanceOf(Function).isRequired,
  pathName: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }) => {
  // get the selected value from lower components (ex: NewTaxRevenuesLicense)
  const fetchSelectedOption = () => {
    try {
      return JSON.parse(localStorage.getItem('formData'));
    } catch (err) {
      return {};
    }
  };

  return {
    selectedOption: fetchSelectedOption(),
    ordinanceRevisionEffectivity:
      _.get(api, `${c.GET_ORDINANCE_REVISION_EFFECTIVITY}.list`) || [],
  };
};

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(OrdinanceRevisionDropDown);
